var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_2967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.509 160H79.509V160.012C36.049 159.477 1 124.096 1 80.509C1 36.5881 36.6058 1 80.509 1C124.412 1 160.018 36.5882 160.018 80.491C160.018 124.394 124.412 160 80.509 160Z",
    fill: "#EC008C",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2645 80.5089C28.2645 73.9062 28.9841 67.6454 32.3664 64.2272C37.2239 59.3157 45.8236 58.56 54.2073 59.2617C55.8445 62.9318 57.2118 67.2136 57.3557 73.5644C58.777 69.0667 59.6765 64.497 59.0648 59.8374C70.2371 61.2946 81.2115 63.0218 91.9341 65.0727C93.2654 68.365 94.2909 72.287 94.3808 77.7023C95.6042 73.8343 96.4498 69.8943 96.2519 65.9003C105.985 67.8613 115.538 70.0742 124.875 72.6289C128.905 73.7263 139.178 76.0471 139.178 80.5089C139.178 84.9706 128.905 87.2914 124.875 88.3889C120.558 89.5762 116.204 90.6737 111.814 91.7172C111.742 88.2809 110.968 84.9166 109.907 81.5703C109.817 86.122 109.079 89.6302 108.072 92.5807C97.7991 94.9195 87.2924 96.9165 76.5879 98.6256C77.1096 94.074 76.2281 89.6482 74.8428 85.2584C74.6989 91.5013 73.3675 95.7651 71.7484 99.3813C67.0168 100.083 62.2312 100.767 57.4276 101.396C54.4592 101.756 51.4007 102.008 48.4322 101.972C49.3318 96.9345 48.4142 92.041 46.885 87.1835C46.7771 93.6242 45.3558 97.942 43.6647 101.648C39.1669 101.054 35.137 99.5971 32.3304 96.7906C28.9481 93.3723 28.2285 87.0935 28.2285 80.4909",
    fill: "#F99D3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_2967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 161,
    height: 161,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.da674bb1e692f826a6639d636ce713a8.svg";
export { ForwardRef as ReactComponent };